import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { camps } from '../../../../models/models.generated';

@Component({
    selector: 'app-sell-camp-summary',
    templateUrl: './sell-camp-summary.component.html',
    styleUrls: ['./sell-camp-summary.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SellCampSummaryComponent {
    summary = input<camps.PurchaseSummaryModel>(null);
}
